import BaseApi from "./base";

class AccionistasApi extends BaseApi {
  constructor() {
    super("accionistas");
  }

  getAccionistaByComparecienteId(comparecienteId) {
    return this.request.get(`/accionistas/by-compareciente/${comparecienteId}`);
  }

  editByComparecienteId(comparecienteId, data) {
    return this.request.put(`/accionistas/by-compareciente/${comparecienteId}`, data);
  }

  partialEditByComparecienteId(comparecienteId, data) {
    return this.request.patch(`/accionistas/by-compareciente/${comparecienteId}`, data);
  }
}

export default new AccionistasApi();
